<template>
  <header class="header" id="top">
    <router-link to='/'>
      <img class="base_image" src="@/assets/image/common/logo_background.png"/>
    </router-link>
  </header>
</template>

<script>
  export default {
    name: "Header",
  }
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: $white_color;
    background: linear-gradient(to bottom, $third_color, $third_color, $third_color, $third_color, $base_color);

    > a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40%;

      > .base_image {
        height: 8vh;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .header {
      > a {
        width: 100%;
      }
    }
  }
</style>
